<template>
  <div class="recordDetail">
    <Navbar :appTitle="$route.meta.title" @ClickRight="ClickRight"/>
    <!--头部-->
    <div class="d-head">
      <div class="content">
        <div class="left">
          <div class="title">{{ detailInfo.code || "-" }}</div>

          <div class="row">
            单据日期：<span style="color:#191f25">{{
              detailInfo.docDate || "-"
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <van-tabs
        v-model="active"
        :offset-top="158"
        line-width="150px"
        color="#1890FF"
    >
      <van-tab title="移仓明细">
        <div
            class="list"
            :style="{
            height: '65vh',
          }"
            v-if="entryDetails && entryDetails.length != 0"
        >
          <div v-for="(item, index) in entryDetails" :key="index" class="wrap">
            <div class="top">
              <div class="icon"></div>
              <div class="title">
                {{ item.goodsCode }} | {{ item.goodsName }}|
                {{ item.goodsSpec }}
              </div>
            </div>
            <div class="center">
              <div>
                <p>
                  <span class="key">产地：</span>
                  <span class="value">{{ item.address || "-" }}</span>
                </p>
                <p>
                  <span class="key">包装规格：</span>
                  <span class="value">{{ item.packageSpec || "-" }}</span>
                </p>
                <p>
                  <span class="key">单位：</span>
                  <span class="value">{{ item.unitName || "-" }}</span>
                </p>
                <p>
                  <span class="key">批号：</span>
                  <span class="value">{{ item.batchCode || "-" }}</span>
                </p>
                <p>
                  <span class="key">生产日期：</span>
                  <span class="value">{{ item.produceDate || "-" }}</span>
                </p>
                <p>
                  <span class="key">移出库位：</span>
                  <span class="value">{{
                      item.goodsNumText + "/" + item.outLatticeNumText
                    }}</span>
                </p>
                <p>
                  <span class="key">移入库位：</span>
                  <span class="value">{{
                      item.goodsNumText + "/" + item.inLatticeNumText
                    }}</span>
                </p>
                <p>
                  <span class="key">数量：</span>
                  <span class="value">{{ item.goodsNumText || "-" }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <van-empty v-else description="移仓明细为空"/>
      </van-tab>
      <van-tab title="单据信息">
        <div
            class="list"
            :style="{
            height: '65vh',
          }"
        >
          <div class="wrap">
            <div class="center">
              <div>
                <p>
                  <span class="key">单据日期：</span>
                  <span class="value">{{ detailInfo.docDate || "-" }}</span>
                </p>
                <p>
                  <span class="key">创建人：</span>
                  <span class="value">{{
                      detailInfo.createByName || "-"
                    }}</span>
                </p>
                <p>
                  <span class="key">创建时间：</span>
                  <span class="value">{{ detailInfo.createTime || "-" }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <van-empty description="单据信息为空"/>
      </van-tab>
    </van-tabs>

    <div v-if="detailInfo&&detailInfo.isArchived!= 1">
      <div class="search-bottom">
        <div class="searchContain"></div>
        <div class="searchContain">
        <span
            class="btn del"
            @click="handleDelete"
            v-show="detailInfo.isArchived != 1"
            v-has="'remove:delete'"
        >删除</span
        >
          <span
              class="btn cancel"
              @click="handleArchive"
              v-show="detailInfo.isArchived != 1"
              v-has="'remove:archive'"
          >归档</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navBar/navBar_right";
import pageList from "@/components/pageList";
import {
  outboundTasksDetail,
  pickingTTasksDetailList,
  formTypeExtendedFieldList,
  outboundOrderDetail,
  outboundOrderdelete,
} from "@/api/mobile";
import store from "@/store";
import {Dialog} from "vant";
import {
  queryShiftInfo,
  queryShiftDetailInfo,
  deleteShiftInfo,
  recordArchive,
} from "@/api/removeAndinventory";

export default {
  name: "outboundOrderDetail", //移仓单
  components: {Navbar, pageList},
  data() {
    return {
      active: 0,
      detailInfo: {
        isArchived: 1
      },
      entryDetails: [],
      pickingDetails: [],
      formTypeExtendedFields: [],
    };
  },
  computed: {},
  mounted() {
  },
  created() {
    store.commit("SET_CURRENT_PREFIX", "/jksaas-produce/produce");
    this.getDetail();
  },
  methods: {
    //删除
    handleDelete(v) {
      Dialog.confirm({
        title: "确定删除吗？",
        message: "删除后数据不可恢复",
        confirmButtonColor: "#2b85e4",
      })
          .then(() => {
            deleteShiftInfo({taskId: this.detailInfo.id}).then((res) => {
              if (res.success) {
                this.$toast(res.message);
                this.searchQuery();
              } else {
                this.$toast(res.message);
              }
            });
          })
          .catch(() => {
          });
    },
    // 归档
    handleArchive(v) {
      Dialog.confirm({
        title: "确定归档吗？",
        message: "归档后状态不可恢复",
        confirmButtonColor: "#2b85e4",
      })
          .then(() => {
            recordArchive({
              ids: this.detailInfo.id,
              entityCode: "WMS_WAREHOUSE_SHIFT",
            }).then((res) => {
              if (res.success) {
                this.$toast(res.message);
                this.searchQuery();
              } else {
                this.$toast(res.message);
              }
            });
          })
          .catch(() => {
          });
    },
    async getDetail() {
      let id = this.$route.query.id;
      queryShiftInfo({taskId: id}).then((res) => {
        if (res.code == 200 && res.result) {
          this.detailInfo = res.result;
        } else {
          // this.$toast(res.message);
        }
      });
      queryShiftDetailInfo({taskId: id}).then((res) => {
        if (res.code == 200 && res.result) {
          this.entryDetails = res.result.records;
        } else {
          this.$toast(res.message);
        }
      });
    },
    ClickRight() {
      this.$router.push({
        path: "/application",
      });
    },
    cancel() {
      // approveType 1:同意 0:拒绝
      this.$router.push({
        path: "/approval",
        query: {approveType: 0, taskId: this.$route.query.taskId},
      });
    },
    confirm() {
      // approveType 1:同意 0:拒绝
      this.$router.push({
        path: "/approval",
        query: {approveType: 1, taskId: this.$route.query.taskId},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.recordDetail {
  height: 100vh;
  overflow: hidden;

  .d-head {
    width: 100%;
    padding: 32px;
    background: #ffffff;

    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        flex: 1;

        .title {
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #191f25;
          line-height: 32px;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }

        .row {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #888888;
          margin-top: 20px;
        }
      }

      .right {
        flex: 1;

        .rightImg {
          display: block;
          width: 55px;
          height: 55px;
          //   margin-left: 0.45rem;
          // border: 1px solid blue;
        }
      }
    }
  }

  .otherTaps {
    background: #ffffff;
    padding: 32px;
    margin-top: 20px;

    .title {
      padding-bottom: 20px;
      border-bottom: 1px solid #eeeeee;

      .icon {
        display: inline-block;
        width: 6px;
        height: 28px;
        background: #1890ff;
      }

      .content {
        width: 126px;
        height: 32px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #191f25;
        line-height: 44px;
        margin-left: 20px;
      }
    }

    .content {
      .row {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        margin-top: 32px;
        display: flex;

        .r-label {
          color: #888888;
          display: block;
          // width: 0.7rem;
          //   border: 1px solid red;
        }

        .r-column {
          display: block;
          color: #191f25;
          width: 500px;
          //   border: 1px solid red;
          //    width: 1rem;
        }
      }

      .fhrow {
        display: flex;

        .fhImg {
          width: 0.55rem;
          height: 0.55rem;
          border-radius: 0.1rem;
        }

        .rt-column {
          width: 2.55rem;
          //   height: 2.55rem;
          margin-left: 0.2rem;

          .rt-title {
            font-size: 0.16rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #191f25;
            margin-bottom: 0.16rem;
          }

          .rt-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.23rem;

            .column {
              //    border: 1px solid red;
              width: 1.5rem;

              .column-t {
                font-size: 0.14rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #888888;
                display: block;
                width: 100%;
                margin-bottom: 0.03rem;
              }

              .column-c {
                font-size: 0.16rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #191f25;
                display: block;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  .search-bottom {
    width: 100%;
    height: 100px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0px;
    padding: 0 11px;
    box-sizing: border-box;
    font-size: 32px;
    font-weight: 500;
    z-index: 9;

    .searchContain {
      .btn {
        display: inline-block;
        box-sizing: border-box;
        width: 124px;
        height: 64px;
        align-items: center;
        border-radius: 6px;
        margin-right: 18px;
        text-align: center;
        line-height: 64px;
      }

      .confirm {
        background: #1890ff;
        color: #ffffff;
      }

      .cancel {
        border: 1px solid #b2b2b2;
        background: #f6f6f6;
        color: #5a5a5a;
      }
    }
  }
}

.detail-bottom {
  height: 1.3rem;
  width: 100%;
  background: #ffffff;
  // background: red;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0.4rem;
  font-size: 24px;

  .btnconfirm {
    padding: 0.2rem 0.4rem;

    background: #1890ff;
    border-radius: 0rem;
    text-align: center;
    line-height: 0.39rem;
    color: #ffffff;
  }

  .btncancel {
    // width: 1.72rem;
    // height: 0.6rem;
    font-size: 0.38rem;
    color: #6c6666;
    padding: 0.2rem 0.4rem;
    background: rgb(255, 255, 255);
    border: 0.01px solid rgba(25, 31, 37, 0.12);
    border-radius: 0rem;
    text-align: center;
    line-height: 0.39rem;
    margin-right: 0.4rem;
  }

  .btndetail {
    // width: 1.72rem;
    // height: 0.6rem;
    font-size: 0.38rem;
    color: #6c6666;
    padding: 0.2rem 0.4rem;
    background: rgb(255, 255, 255);
    border: 0.01px solid rgba(25, 31, 37, 0.12);
    border-radius: 0rem;
    text-align: center;
    line-height: 0.39rem;
    margin-right: 0.4rem;
  }
}

/deep/ .van-tabs__line {
  background-color: rgb(24, 144, 255);
  width: 150px !important;
  transform: translateX(62.5px) translateX(-50%);
  transition-duration: 0.3s;
}

.contentBox {
  margin-top: 1.38rem;
}

.otherMargin {
  height: 0.1rem;
  background: #f5f5f5;
}

.bottomLine {
  height: 0.01rem;
  background-color: #f0f0f0;
  margin: 0.16rem 0.16rem 0 0.06rem;
}

.ExamineBottom {
  height: 0.5rem;
}

.status {
  display: inline-block;
  margin-top: 0.16rem;
  padding: 0.03rem 0.08rem;
  background: #edf6ff;
  border-radius: 0.02rem;
  font-size: 0.11rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #3774ac;
}

.list {
  height: 65vh;
  overflow: scroll;

  .wrap {
    background: #fff;
    margin: 24px 0;
    padding: 30px;
    width: 100vw;

    .top {
      display: flex;
      justify-content: flex-start;

      .icon {
        width: 6px;
        height: 36px;
        background: #1890ff;
        margin-top: 6px;
        margin-right: 20px;
      }

      .title {
        width: 620px;
        margin-right: 20px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #191f25;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .spot img {
        width: 40px;
        height: 40px;
      }
    }

    .center {
      p {
        margin: 16px 25px;
        font-size: 28px;
        display: flex;
        position: relative;

        .key {
          color: #888888;
        }

        .value {
          color: #191f25;
          width: 380px;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .arrow {
          color: #1890ff;
          // float: right;
          // margin-right: -0.05rem;
          // display: block;
          position: absolute;
          right: -10px;
        }
      }

      .showAll {
        background: #f5f8ff;
        width: 100vw;
        margin-left: -0.15rem;
        padding: 0.15rem;
        margin-bottom: 0.15rem;
      }

      .fontAno {
        font-size: 30px;
        padding-left: 20px;
      }
    }

    .label {
      margin-left: -0.03rem;
      margin-top: -0.1rem;

      span {
        height: 0.16rem;
        background: #f0f6fe;
        color: #1890ff;
        margin-right: 0.1rem;
        padding: 0.03rem 0.08rem;
        font-size: 0.11rem;
        border-radius: 0.03rem;
      }
    }

    .foot {
      // height: 0.33rem;
      // line-height: 0.33rem;
      display: flex;
      justify-content: space-between;
      // margin: 0.15rem 0.12rem 0 0.12rem;
      font-size: 0.14rem;

      .pictures {
        width: 0.33rem;
        height: 0.33rem;
        line-height: 0.33rem;
        text-align: center;
        color: #fff;
        background: #1890ff;
        display: block;
        border-radius: 0.06rem;
        font-size: 0.12rem;
        margin-right: 0.1rem;
      }

      .text {
        width: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .opera {
        color: #1890ff;
        font-size: 0.14rem;
      }
    }
  }
}

.del {
  background: #ff5f4e;
  color: #fff;
}
</style>
